import { Dayjs } from 'dayjs'
import { ETenderType } from 'types/tender'

export enum ETenderEvaluationCriteriaType {
  PROCUREMENT = 'PROCUREMENT',
  TECHNICAL = 'TECHNICAL',
}

export enum TMemberRole {
  CHAIRMAN = 'CHAIRMAN',
  ORDINARY = 'ORDINARY',
}

export interface ITenderProtocolData {
  tenderOrgName: string
  tenderOrgAddress: string
  tenderOrgPrincipal: string
  protocolDate: string | null | Dayjs
  tenderNumber: string
  tenderName: string
  tenderMethod: ETenderType
  estimatedPriceAmount: string
  participationFeeAmount: string
  announcementDate: string | null | Dayjs
  changesOnTermsConditions: string
  procurementEvaluationScores: [
    {
      orgName: string
      totalPrice: string
      calculationMistake: string
      finalPrice: string
      procurementPoint: string
      finalPoint: string
    },
  ]
  commissionOrderInfo: {
    orderDateAndNumber: string | null
    orderFileId: string | null
  }
  commissionMembers: [
    {
      fullName: string
      workplaceAndPosition: string
      memberRole: TMemberRole | string
    },
  ]
  invitations: [
    {
      orgName: string
      orgCountry: string
      orgTaxId: string
      sentAt: string
      registrationNumber: string
    },
  ]
  submitterOrganizations: [
    {
      orgName: string
      orgCountry: string
      orgTaxId: string
      submittedAt: string
      businessSizeRemark: string
      deliveryTerms: string
      bidPriceAndCurrency: string
    },
  ]
  envelopeOpeningTime: string | null | Dayjs
  technicalAssessments: [
    {
      orgName: string
      result: string
      note: string
    },
  ]
  technicalAssessmentNote: string
  procurementEvaluationResults: [
    {
      orgName: string
      totalPriceSum: string
      deliveryCosts: string
      customCosts: string
      otherCosts: string
      vat: string
      finalPrice: string
    },
  ]
  procurementEvaluationResultNote: string
  rejectedSubmitterOrganizations: [
    {
      orgName: string
      reason: string
    },
  ]
  procurementCommitteeLetterNumber: string
  procurementEvaluations: [
    {
      orgName: string
      totalPrice: string
      calculationMistake: string
      finaPrice: string
      procurementPoint: string
      finalPoint: string
    },
  ]
  submitterOrganizationRanks: [
    {
      orgName: string
    },
  ]
  procurementDivisionDecision: string
  termsGuaranteePercentage: string
  contractGuarantee: string
  downPaymentAmount: string
  downPaymentGuarantee: string
  complaintsData: string
  commissionExperts: string
  commissionExpertNote: string
  commissionEvaluations: [
    {
      memberName: string
      memberSignature: string
      decisionDate: string
      specialNote: string
    },
  ]
  tenderEvaluationCriteria: {
    procurementBidWeight: number
    technicalBidWeight: number
    items: [
      {
        orgName: string
        procurementScore: number
        technicalScore: number
      },
    ]
  }
  docRequirementEligibilityEvaluation: {
    orgNames: string[]
    criteria: [
      {
        criteria: string
        eligibility: string
        orgInputs: string[]
      },
    ]
  }
}

export interface ITenderProtocol {
  tenderId: string
  tenderOrgId: string
  createdAt: string
  updatedAt: string
  data: ITenderProtocolData
}
